"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const utils_1 = require("./utils");
const index_1 = require("../index");
const TimeZoneRow_1 = require("./TimeZoneRow");
const PredicateDateTimePageSelector = ({ device, value, updatePageSelected, }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { style: {
            alignItems: 'center',
            display: 'flex',
            height: device === 'Mobile' ? 72 : 56,
            justifyContent: 'space-between',
            boxSizing: 'border-box',
            borderBottom: `1px solid ${index_1.titanium}`,
        }, onClick: () => updatePageSelected('dateOverview') },
        React.createElement("div", { style: {
                display: 'flex',
            } },
            React.createElement(index_1.Text, { text: utils_1.getDisplayDate(value), size: device === 'Mobile' ? 'large' : 'medium', textStyle: {
                    marginRight: 42,
                } }),
            React.createElement(index_1.Text, { text: utils_1.getDisplayTime(value), size: device === 'Mobile' ? 'large' : 'medium' })),
        React.createElement(index_1.ChevronRightIcon, { fill: index_1.silver })),
    React.createElement(TimeZoneRow_1.default, { device: device, onClick: () => updatePageSelected('selectTimeZone'), value: value })));
exports.default = PredicateDateTimePageSelector;
